import { Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../lib/site-data";

export const Footer = () => {
  return (
    <footer
      className="relative border-t border-white/5 pt-10 pb-6"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Service Area + Contact + Socials */}
        <div>
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-2">
            Service Area
          </h4>
          <ul className="space-y-1 text-[13px] text-slate-300">
            {BRAND.counties.map((c) => (
              <li key={c}>- {c}</li>
            ))}
          </ul>

          <h4 className="text-[11px] uppercase tracking-[0.18em] text-slate-400 mt-6 mb-2">
            Contact
          </h4>
          <ul className="space-y-1 text-[13px] text-slate-300">
            {BRAND.phones.map((p) => (
              <li key={p.tel}>
                <a
                  href={`tel:${p.tel}`}
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  {p.name} · {p.value}
                </a>
              </li>
            ))}
            <li>
              <a
                href={`mailto:${BRAND.email}`}
                className="hover:text-[#D4AF37] transition-colors"
              >
                {BRAND.email}
              </a>
            </li>
          </ul>
          <div className="mt-4 flex items-center gap-4">
            <a
              href={BRAND.socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-[#D4AF37] transition-colors"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a
              href={BRAND.socials.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-[#D4AF37] transition-colors"
              aria-label="Facebook"
              data-testid="footer-facebook"
            >
              <Facebook size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        {/* Hours — middle on mobile, right on desktop */}
        <div className="md:order-3">
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-2">
            Hours
          </h4>
          <ul className="space-y-1 text-[13px] text-slate-300 max-w-[260px]">
            {BRAND.hours.map(([day, val]) => (
              <li key={day} className="flex items-center justify-between gap-3">
                <span className="text-slate-500 w-10">{day}</span>
                <span className="text-right">{val}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Legal — bottom on mobile, middle on desktop */}
        <div className="md:order-2">
          <h4 className="text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-2">
            Legal
          </h4>
          <ul className="space-y-1 text-[13px] text-slate-300">
            <li>
              <Link
                to="/privacy"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-privacy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-terms"
              >
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-4 border-t border-white/5 max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 text-[11px] text-slate-500 text-center">
        © {new Date().getFullYear()} DN Flooring · Licensed & insured · Florida
      </div>
    </footer>
  );
};
